import { Component, Input } from '@angular/core';
import { EbayBrowseItemSummery } from 'src/app/models/ebay';

@Component({
    selector: 'ebay-browse-item',
    templateUrl: './ebay-browse-item.component.html',
    styleUrls: ['./ebay-browse-item.component.css'],
    standalone: false
})
export class EbayBrowseItemComponent {
  @Input() ebayBrowseItems: EbayBrowseItemSummery;

}
